import * as React from 'react';
import { observer } from 'mobx-react';
import { Form } from 'react-final-form';
import { Group } from '../../store/models/Group';
import { Page, TLCode } from '../../common/enums';
import { Instance } from 'mobx-state-tree';
import { CheckboxInputFormField, TextInputFormField, NumberInputFormField } from '../common/form';
import VerticalForm from '../common/form/VerticalForm';
import styled from '@emotion/styled';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { toJS } from 'mobx';
import LanguageFormField from '../common/form/LanguageFormField';
// import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { Button, Intent, InputGroup } from '@blueprintjs/core';
import { Link } from 'react-router-dom';
import { TranslatedMessage } from '../common/translation';
import { IconNames } from '@blueprintjs/icons';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { PhotoshopPicker, ChromePicker } from 'react-color';
import { MaxDivHeightScaler } from 'ag-grid-community/dist/lib/rendering/maxDivHeightScaler';

interface GroupFormProps extends WithTranslateProps {
  group?: Instance<typeof Group>;
  groupList?: Array<Instance<typeof Group>>;
  save: (data: any) => void;
}

interface GroupFormState {
  loading: boolean;
  selectedColor: string;
  defaultColor?: string;
  changeColor?: string,
  color?: string;
}

@observer
class GroupForm extends React.Component<GroupFormProps, GroupFormState> {
  constructor(props: GroupFormProps) {
    super(props);
    this.state = {
      loading: false,
      selectedColor: props.group?props.group.color:'',
      // defaultColor: "#999",
      // changeColor: "#999",
      // color: props.group?props.group.color:'#999'
    };
  }

  async componentDidMount() {
    this.setState({ color: this.props.group?this.props.group.color:'#999'});//,
    // changeColor: this.props.group?this.props.group.color:'#999',
    // defaultColor: this.props.group?this.props.group.color:'#999' });
  };
  
  onColorChangeComplete = (event) => {
    this.setState({ color: event.rgb, changeColor: event.hex });
  };

  onAcceptColorChange = (event) => {
    this.setState({ selectedColor: event.hex });
  };

  onCancelColorChange = (event) => {
    const oldcolor = this.props.group!.color
    this.setState({color: oldcolor})
    this.onAcceptColorChange(event)
  };

  public render() {
    const { group, translate, save } = this.props;
    // const color = this.state.color?this.state.color:(group?group.color:"#999");
    const currentColor = this.props.groupList && group?'#' + this.props.groupList.filter(grp => grp.name === group.name)[0].color: '';
    const newColor = this.state.changeColor?this.state.changeColor:'';
    return (
      <Form
        initialValues={toJS(group) || {}}
        onSubmit={save}
        render={({ handleSubmit, form, hasValidationErrors, dirty }) => (
          <form onSubmit={handleSubmit}>
            <LeaveRouteDirtyWrapper blockChange={dirty} />
            <Container>
              <VerticalForm labelWidth={175}>
                <TextInputFormField
                  name="name"
                  label={TLCode.GROUP_Name}
                  inline={true}
                  fill={true}
                  required={true}
                />
                <TextInputFormField
                  name="description"
                  label={TLCode.GROUP_Description}
                  inline={true}
                  fill={true}
                  required={true}
                />
                <DivLine style={{ alignItems: 'left'}}>
                  <br/><b><TranslatedMessage id={TLCode.GROUP_TargetCounts} /></b><br/><br/>
                </DivLine>
                <DivLine>
                  <DivColumn>
                    <TextInputFormField
                      name="targetDutyCount"
                      label={TLCode.GROUP_TargetDutyCount}
                      inline={true}
                      fill={true}
                      required={true}
                    />
                  </DivColumn>
                  <DivColumn>
                    <TextInputFormField
                      name="targetDayDutyCount"
                      label={TLCode.GROUP_TargetDayDutyCount}
                      inline={true}
                      fill={true}
                      required={true}
                    />
                  </DivColumn>
                  <DivColumn>
                    <TextInputFormField
                      name="targetNightDutyCount"
                      label={TLCode.GROUP_TargetNightDutyCount}
                      inline={true}
                      fill={true}
                      required={true}
                    />
                  </DivColumn>
                </DivLine>
                <DivLine style={{ alignItems: 'left'}}>
                  <br/><b><TranslatedMessage id={TLCode.GROUP_Display} /></b><br/><br/>
                </DivLine>
                <DivLine>
                  <DivColumn>
                    <DivLine>
                      <DivColumn>
                      <TextInputFormField
                        name="color"
                        label={TLCode.GROUP_Color}
                        inline={true}
                        fill={true}
                        required={true}
                        style={{ background: currentColor}}
                      />
                      </DivColumn>
                      <DivColumn>
                        <InputGroup
                          value={this.state.changeColor}
                          disabled
                          style={{ background: newColor}}
                        />
                      </DivColumn>
                    </DivLine>
                    {group &&
                      <>
                      <DivLine>
                        <DivColumn>
                          <ChromePicker
                            color={this.state.color}
                            onChange={this.onColorChangeComplete}
                          ></ChromePicker>
                          {/* <PhotoshopPicker
                            id='pick'
                            color={group.color}
                            onChange={this.onColorChangeComplete}
                            onAccept={this.onAcceptColorChange}
                            onCancel={this.onCancelColorChange}
                          /> */}
                        </DivColumn>
                        <DivColumn style={{ width: 100 }}>
                          {this.props.groupList && this.props.groupList!.map(grp => {
                            return(
                            <>
                            <div id={grp.name} style={{ background: '#'+grp.color }}>{grp.name}</div>
                            </>)})
                          }
                        </DivColumn>
                      </DivLine>
                      </>}
                  </DivColumn>
                </DivLine>
                {/* <TextInputFormField name="address" label={TLCode.Group_Address} inline={true} fill={true} />
                <LanguageFormField name="language" required={true} />
                <SimpleTextFormContent label={TLCode.IS_ACTIVE} small={false}>
                  <CheckboxInputFormField name="isActive" inline={true} required={false} />
                </SimpleTextFormContent> */}
              </VerticalForm>
              <ButtonsContainer>
                <Button>
                  <Link to={`${Page.Groups}`}>
                    <TranslatedMessage id={TLCode.BackToList} />
                  </Link>
                </Button>
                <Button
                  text={translate(TLCode.GENERAL_Cancel)}
                  icon={IconNames.ERASER}
                  intent={Intent.PRIMARY}
                  onClick={() => form.reset()}
                  disabled={!dirty}
                />
                <Button
                  type={'submit'}
                  text={translate(TLCode.GENERAL_Save)}
                  icon={IconNames.FLOPPY_DISK}
                  intent={Intent.PRIMARY}
                  disabled={hasValidationErrors || !dirty}
                />
              </ButtonsContainer>
            </Container>
          </form>
        )}
      />
    );
  }
}

export default withTranslate(GroupForm);

const Container = styled.div`
  display: flex;
  width: 70%;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  & button {
    margin-left: 5px;
  }
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;